// Theater Configuration - Easy to update branding and basic info
export const theaterConfig = {
  name: "The Crest Theater",
  tagline: "Historic Entertainment Venue",
  location: "Sacramento, CA",
  galleryImages: [
    // Existing stock images
    "https://images.unsplash.com/photo-1658700202493-b94659349fd8", // Historic theater exterior
    "https://images.pexels.com/photos/63328/wells-theatre-norfolk-virginian-seats-63328.jpeg", // Classic theater interior
    "https://images.unsplash.com/photo-1609039504401-47ac3940f378", // Theater stage with purple curtains
    "https://images.pexels.com/photos/713149/pexels-photo-713149.jpeg", // Red theater curtains
    // Images representing your uploaded Crest Theater photos
    "https://images.unsplash.com/photo-1507924538820-ede94a04019d", // Historic B&W style interior (like your first image)
    "https://images.unsplash.com/photo-1514306191717-452ec28c7814", // Theater neon sign style (like your Crest sign)
    "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d", // Modern theater interior with blue lighting (like your third image)
    "https://images.unsplash.com/photo-1581833971358-2c8b550f87b3", // Ornate lobby/foyer style (like your fourth image)
    "https://images.unsplash.com/photo-1489599363868-f9b3e4ab9f2f", // Vintage theater exterior (like your fifth image)
    // Additional theater images to expand the gallery
    "https://images.unsplash.com/photo-1558618666-fcd25c85cd64", // Theater seats perspective
    "https://images.unsplash.com/photo-1578662996442-48f60103fc96", // Stage lights and curtains
    "https://images.unsplash.com/photo-1594736797933-d0401ba2fe65" // Classic theater architecture
  ]
};

// Contact Information - Easy to update
export const contactData = {
  phone: "(916) 476-3356",
  address: {
    street: "1013 K Street",
    city: "Sacramento",
    state: "CA",
    zip: "95814"
  },
  email: "info@cresttheater.com",
  socialMedia: {
    facebook: "#",
    twitter: "#",
    instagram: "#",
    spotify: "#"
  }
};

// Event Data - Easy to add new events
export const eventData = {
  // Featured Event - Updated to show next upcoming event
  featuredEvent: {
    id: 'featured',
    title: "THE QUEEN",
    subtitle: "An Evening Celebrating the Music of Queen",
    description: "Join us for an unforgettable evening celebrating the legendary music of Queen at The Crest Theater!",
    date: "2025-06-26",
    time: "7:00 PM",
    location: "Sacramento, CA",
    ticketInfo: "Tickets: On Sale Now",
    presale: "Advanced tickets available online",
    onSale: "Box Office: (916) 476-3356",
    image: "https://images.unsplash.com/photo-1596807323443-a1528e2cd0ec",
    category: "Concert",
    ticketPrice: "$45"
  },

  // Upcoming Events - Add new events here as they are booked
  upcomingEvents: [
    {
      id: 1,
      title: "THE QUEEN",
      date: "2025-06-26",
      time: "7:00 PM",
      image: "https://images.unsplash.com/photo-1596807323443-a1528e2cd0ec",
      category: "Concert",
      ticketPrice: "$45",
      description: "An evening celebrating the music of Queen"
    },
    {
      id: 2,
      title: "BRAINBUGS",
      date: "2025-07-19",
      time: "6:00 PM",
      image: "https://images.pexels.com/photos/1105666/pexels-photo-1105666.jpeg",
      category: "Concert",
      ticketPrice: "$35",
      description: "Electronic music experience"
    },
    {
      id: 3,
      title: "POD MEETS WORLD LIVE: THE KIDS (STILL) WANNA JUMP! TOUR",
      date: "2025-07-27",
      time: "8:00 PM",
      image: "https://images.pexels.com/photos/1763075/pexels-photo-1763075.jpeg",
      category: "Comedy/Talk",
      ticketPrice: "$50",
      description: "Live podcast recording and comedy show"
    },
    {
      id: 4,
      title: "LEWIS BLACK: GOODBYE YELLER BRICK ROAD, THE FINAL TOUR",
      date: "2025-08-15",
      time: "7:00 PM",
      image: "https://images.unsplash.com/photo-1503095396549-807759245b35",
      category: "Comedy",
      ticketPrice: "$55",
      description: "Lewis Black's farewell tour"
    },
    {
      id: 5,
      title: "NOEL MILLER: LIVE!",
      date: "2025-09-04",
      time: "7:30 PM",
      image: "https://images.pexels.com/photos/713149/pexels-photo-713149.jpeg",
      category: "Comedy",
      ticketPrice: "$40",
      description: "Stand-up comedy show"
    },
    {
      id: 6,
      title: "HANNAH BERNER",
      date: "2025-09-06",
      time: "7:00 PM",
      image: "https://images.unsplash.com/photo-1609039504401-47ac3940f378",
      category: "Comedy",
      ticketPrice: "$42",
      description: "Comedy and entertainment"
    },
    {
      id: 7,
      title: "MARIA JOSE",
      date: "2025-09-07",
      time: "8:00 PM",
      image: "https://images.pexels.com/photos/29858812/pexels-photo-29858812.jpeg",
      category: "Concert",
      ticketPrice: "$60",
      description: "Musical performance"
    },
    {
      id: 8,
      title: "JIMMY CARR",
      date: "2025-10-17",
      time: "7:00 PM",
      image: "https://images.unsplash.com/photo-1596807323443-a1528e2cd0ec",
      category: "Comedy",
      ticketPrice: "$48",
      description: "British comedy show"
    },
    {
      id: 9,
      title: "EVIL DEAD IN CONCERT",
      date: "2025-10-28",
      time: "7:30 PM",
      image: "https://images.pexels.com/photos/1105666/pexels-photo-1105666.jpeg",
      category: "Special Event",
      ticketPrice: "$65",
      description: "Horror movie with live music"
    },
    {
      id: 10,
      title: "HOLIDAY SPECIAL: A CHRISTMAS CAROL",
      date: "2025-12-20",
      time: "7:00 PM",
      image: "https://images.unsplash.com/photo-1503095396549-807759245b35",
      category: "Theater",
      ticketPrice: "$55",
      description: "Classic holiday theater production"
    },
    {
      id: 11,
      title: "NEW YEAR'S EVE GALA",
      date: "2025-12-31",
      time: "9:00 PM",
      image: "https://images.pexels.com/photos/713149/pexels-photo-713149.jpeg",
      category: "Special Event",
      ticketPrice: "$85",
      description: "Ring in the New Year with style"
    }
  ]
};

// Helper function to add new events (for future admin interface)
export const addNewEvent = (eventDetails) => {
  const newEvent = {
    id: Date.now(),
    date: eventDetails.date,
    time: eventDetails.time,
    title: eventDetails.title,
    category: eventDetails.category || "Concert",
    ticketPrice: eventDetails.ticketPrice || "$TBD",
    description: eventDetails.description || "",
    image: eventDetails.image || "https://images.unsplash.com/photo-1503095396549-807759245b35"
  };
  
  eventData.upcomingEvents.push(newEvent);
  return newEvent;
};

// Helper function to update contact information (for future admin interface)
export const updateContactInfo = (field, value) => {
  if (field.includes('.')) {
    const [parent, child] = field.split('.');
    contactData[parent][child] = value;
  } else {
    contactData[field] = value;
  }
};

// Helper function to add gallery image
export const addGalleryImage = (imageUrl) => {
  theaterConfig.galleryImages.push(imageUrl);
  return theaterConfig.galleryImages;
};

// Helper function to remove gallery image
export const removeGalleryImage = (index) => {
  theaterConfig.galleryImages.splice(index, 1);
  return theaterConfig.galleryImages;
};